import routes from '@/modules/trip/trip-routes';
import store from '@/modules/trip/trip-store';

export default {
  routes,
  store,
};
